var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPandas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 210.21 280.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-1{fill:#130754;}.cls-2{fill:#48e5ac;}.cls-3{fill:#e70488;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title6"
  }, "Artboard 61") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title6"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 74.51,
    y: 43.03,
    width: 24.09,
    height: 50.02,
    id: "rect8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 74.51,
    y: 145.78,
    width: 24.09,
    height: 50.02,
    id: "rect10"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 74.51,
    y: 107.65,
    width: 24.09,
    height: 23.6,
    id: "rect12",
    style: {
      fill: "#ffca00",
      fillOpacity: 1
    }
  }), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 35.81,
    y: 84.15,
    width: 24.09,
    height: 166.27,
    id: "rect14"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 112.41,
    y: 187.05,
    width: 24.09,
    height: 50.02,
    id: "rect16"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 112.41,
    y: 84.21,
    width: 24.09,
    height: 50.02,
    id: "rect18"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 112.41,
    y: 148.84,
    width: 24.09,
    height: 23.6,
    id: "rect20"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 150.3,
    y: 30,
    width: 24.09,
    height: 166.27,
    id: "rect22"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPandas);
export default __webpack_public_path__ + "static/media/pandas.d1ffc0d3f607aeb68712e53d66b92191.svg";
export { ForwardRef as ReactComponent };